module.exports = __webpack_public_path__ + "static/media/Aatrox.df4f3e50.png";